export default "__VITE_ASSET__CtX2zCqe__"